function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

// TODO: We need to keep track of the "updates" separately so the forms will use those as their values
// So that they can be diffed against the "instance"s when updating.
const _ = require('lodash');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const {
  SimpleFlow,
  Schedule
} = require('../entities');

function _invoke(body, then) {
  var result = body();

  if (result && result.then) {
    return result.then(then);
  }

  return then(result);
}

const AccessContext = require('../repositories/contexts/access-context');

function _empty() {}

const OfferLocalizerFactory = require('../entities/offer-localizer');

function _invokeIgnored(body) {
  var result = body();

  if (result && result.then) {
    return result.then(_empty);
  }
}

const {
  schedulesToPrecheckParams
} = require('../utils/scheduleToPrecheckParam');

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

const buildSchedulesOfAllTypes = usableScheduleValues => {
  const types = Schedule.TYPE_NAMES;
  const usableSchedule = new Schedule(Object.assign({}, usableScheduleValues, {
    type: types.usable
  }));
  const visibleSchedule = usableSchedule.copyToVisible();
  const canBuildDiscoverableSchedule = !usableScheduleValues.isHidden; // add discoverableSchedule onto return if not hidden

  if (canBuildDiscoverableSchedule) {
    return [usableSchedule, visibleSchedule, usableSchedule.copyToDiscoverable() // discoverableSchedule
    ];
  }

  return [usableSchedule, visibleSchedule];
};

class OfferUpdatePipeline {
  /*:: static deprecatedValidateWithOldOfferModel: (Offer) => ?string */
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context;
    this.instances = {};
  }

  setInstance(key
  /*: string*/
  , instance
  /*: any*/
  ) {
    this.instances[key] = instance;
  }

  getInstance(key
  /*: string*/
  ) {
    return this.instances[key];
  }

  deprecatedGetOldOfferModel() {
    // Load initial formValues for packages/portal/src/components/offers/NewEditOfferContainer.js
    // FIXME: This garbage exists because the Offer Edit form expects Offer to be a single model
    // FIXME: Once that's fixed, we won't need this
    const offer = Object.assign({}, this.getInstance('offer')); // HACK: Ensure flags array is deep cloned because ListSelectorField just updates the same array instance

    offer.flags = offer.flags.slice(); // Offer Schedules Instance, which may contain up to 3 schedule(s) ie. usable, visible, discoverable

    const offerSchedules = this.getInstance('schedules');
    const usableOfferSchedule = offerSchedules.filter(s => s.type === undefined || s.type === Schedule.TYPE_NAMES.usable); // Does 'offerSchedules' instance contain a schedule of type: 'discoverable'?

    let isHidden = !offerSchedules.some(item => item.type === Schedule.TYPE_NAMES.discoverable); // By default, when creating a new offer, the admin-sdk outputs ONE schedules[0]
    // We check if this is true and return hidden: false
    // So, any new created Offers will be visible

    if (offerSchedules.length === 1) isHidden = false; // Can't use spread operator - "This experimental syntax requires enabling the parser plugin: 'objectRestSpread'"

    usableOfferSchedule.forEach(schedule => {
      // .forEach instead of .map when iterating for side-effects
      schedule.isHidden = isHidden; // eslint-disable-line no-param-reassign

      return schedule;
    });
    offer.schedules = usableOfferSchedule;
    offer.locations = this.getInstance('locations');
    offer.discoverableRegions = this.getInstance('discoverableRegions');
    offer.flow = this.getInstance('flow');
    return offer;
  }

  deprecatedUpdateWithOldOfferModel(model
  /*: Offer*/
  ) {
    // FIXME: This garbage exists because the Offer Edit form expects Offer to be a single model
    // FIXME: Once that's fixed, we won't need this
    const updates = {};
    updates.offer = _.omit(model, ['schedules', 'locations', 'regions', 'flow']);
    updates.schedules = model.schedules;
    updates.locations = model.locations;
    updates.discoverableRegions = model.discoverableRegions;
    updates.flow = model.flow;
    return this.update(updates);
  }

  resetOnNewOfferTypeChange(formValues, isPriorityDisabled) {
    const getPriorityValue = () => {
      // If 'formValues.priority = undefined' && '!isPriorityDisabled'
      // Priority will default to a value of 2 (high priority). Need tobe 0 (default) */
      let priorityValue = 0;
      if (isPriorityDisabled || formValues.priority) priorityValue = formValues.priority;
      return priorityValue; // 'undefined' OR '-2, -1, 0, 1, 2'
    };

    const resetValues = { ...formValues,
      flow: this.getInstance('flow'),
      priority: getPriorityValue() // TODO Should not have to manually reset priorityValue field

    };
    return resetValues;
  }

  update(updates
  /*: Object*/
  ) {
    const _this = this;

    return _call(function () {
      return _await(_this.planLimitPrecheck(updates), function () {
        return _await(_this.conditionallyDisable(updates), function () {
          return _await(_this.updateSchedules(updates), function () {
            return _await(_this.createOrUpdateOffer(updates), function () {
              return _await(_this.updateLocalizations(updates), function () {
                return _await(_this.updateLocations(updates), function () {
                  return _await(_this.updateRegions(updates), function () {
                    return _await(_this.updateFlow(updates), function () {
                      return _await(_this.updateSlug(updates), function () {
                        return _await(_this.updatePins(updates), function () {
                          return _await(_this.conditionallyEnable(updates), function () {
                            return _this;
                          });
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  }

  createOrUpdateOffer(updates
  /*: Object*/
  ) {
    const _this2 = this;

    return _call(function () {
      const offer = _this2.getInstance('offer'); // HACK: Set offer's 'limited' flag based on the redemption flow


      return _await(_invoke(function () {
        if (updates.flow) {
          return _await(_this2.syncFlowTemplate(updates.flow), function () {
            const isLimited = SimpleFlow.fromFlow(SimpleFlow.toFlow(updates.flow)).vars.isLimited;
            const flags = updates.offer && updates.offer.flags; // eslint-disable-next-line no-param-reassign

            if (isLimited && flags && !flags.includes('limited')) updates.offer.flags = flags.concat('limited'); // eslint-disable-next-line no-param-reassign

            if (!isLimited && flags && flags.includes('limited')) updates.offer.flags = _.without(flags, 'limited');
          });
        }
      }, function () {
        const locales = _this2.getInstance('locales');

        OfferLocalizerFactory(locales).applyDefaultLocalizations(updates.offer);
        return offer.id ? _this2.updateOffer(updates) : _this2.createOffer(updates);
      }));
    });
  }

  updateOffer(updates
  /*: Object*/
  ) {
    const _this3 = this;

    return _call(function () {
      const offerInstance = _this3.getInstance('offer');

      const {
        offer: offerUpdates
      } = updates;

      const {
        propertyId,
        businessId
      } = _this3.context.serialize();

      return _await(_this3.client.properties.for(propertyId).businesses.for(businessId).offers.for(offerInstance.id).coreUpdate(offerInstance, offerUpdates), function (updatedOffer) {
        _this3.setInstance('offer', updatedOffer);
      });
    });
  }

  createOffer(updates
  /*: Object*/
  ) {
    const _this4 = this;

    return _call(function () {
      const {
        offer: offerUpdates
      } = updates;

      const {
        propertyId,
        businessId
      } = _this4.context.serialize();

      return _await(_this4.client.properties.for(propertyId).businesses.for(businessId).offers.coreCreate(offerUpdates), function (createdOffer) {
        _this4.setInstance('offer', createdOffer);
      });
    });
  }

  updateLocalizations(updates
  /*: Object*/
  ) {
    const _this5 = this;

    return _call(function () {
      const offer = _this5.getInstance('offer');

      const offerUpdates = updates.offer;

      const locales = _this5.getInstance('locales');

      const {
        propertyId,
        businessId
      } = _this5.context.serialize();

      const localizations = OfferLocalizerFactory(locales).getLocalizations(offerUpdates);

      const offerRepo = _this5.client.properties.for(propertyId).businesses.for(businessId).offers.for(offer.id);

      return Promise.all(localizations.map(({
        locale,
        content
      }) => offerRepo.setLocalization({
        locale,
        content
      })));
    });
  }

  createSchedule(updatedSchedule) {
    const _this6 = this;

    return _call(function () {
      const schedulesRepo = _this6.client.schedules;
      return _await(schedulesRepo.create(updatedSchedule));
    });
  }

  updateSchedules(updates
  /*: Object*/
  ) {
    const _this7 = this;

    return _call(function () {
      const builtSchedules = buildSchedulesOfAllTypes(updates.schedules[0]);
      return _await(Promise.all(builtSchedules.map(schedule => _this7.createSchedule(schedule))), function (schedules) {
        /* eslint-disable-next-line no-param-reassign */
        updates.offer.scheduleIds = schedules.map(({
          id
        }) => id);
      });
    });
  }

  updateLocations(updates
  /*: Object*/
  ) {
    const _this8 = this;

    return _call(function () {
      const {
        id: offerId
      } = _this8.getInstance('offer');

      const currentLocations = _this8.getInstance('locations');

      const {
        locations: newLocations
      } = updates;

      const {
        propertyId,
        businessId
      } = _this8.context.serialize(); // FIXME: Move the actual comparison and update calls to a separate repo


      const toAdd = _.difference(newLocations, currentLocations);

      const toRemove = _.difference(currentLocations, newLocations);

      const offerRepo = _this8.client.properties.for(propertyId).businesses.for(businessId).offers.for(offerId);

      const addProcess = toAdd.map(id => offerRepo.addLocation(id));
      const removeProcess = toRemove.map(id => offerRepo.removeLocation(id));

      _this8.setInstance('locations', newLocations);

      return Promise.all([...addProcess, ...removeProcess]);
    });
  }

  updateRegions(updates
  /*: Object*/
  ) {
    const _this9 = this;

    return _call(function () {
      const {
        id: offerId
      } = _this9.getInstance('offer');

      const {
        propertyId,
        businessId
      } = _this9.context.serialize(); // Reconcile Offer Regions


      const offerRegionsRepo = _this9.client.properties.for(propertyId).businesses.for(businessId).offers.for(offerId).regions;

      return _await(offerRegionsRepo.reconcile(_.map(_this9.getInstance('discoverableRegions'), r => r.id), _.map(updates.discoverableRegions || [], r => r.id), {
        discoverable: true
      }), function () {
        _this9.setInstance('discoverableRegions', updates.discoverableRegions);
      });
    });
  }

  updateFlow(updates
  /*: Object*/
  ) {
    const _this10 = this;

    return _call(function () {
      const {
        id: offerId
      } = _this10.getInstance('offer');

      const {
        propertyId,
        businessId
      } = _this10.context.serialize(); // TODO: Diff old and new flows and update only what's changed
      // TODO: Or at least check if they're the same so we don't update
      // (Add .diff method to SimpleFlow and Flow)


      const newSimpleFlow = updates.flow;
      return newSimpleFlow ? _await(_this10.syncFlowTemplate(newSimpleFlow), function () {
        const updateFlow = SimpleFlow.toFlow(newSimpleFlow);

        const offerFlowRepo = _this10.client.properties.for(propertyId).businesses.for(businessId).offers.for(offerId).flows;

        return _await(offerFlowRepo.create(updateFlow), function (newFlow) {
          _this10.setInstance('flow', SimpleFlow.fromFlow(newFlow));
        });
      }) : _await();
    });
  }

  syncFlowTemplate(newSimpleFlow
  /*: SimpleFlow*/
  ) {
    const _this11 = this;

    return _call(function () {
      const existingSimpleFlow = _this11.getInstance('flow');

      const newGenerator = SimpleFlow.determineRequiredGenerator(newSimpleFlow);
      const existingGenerator = SimpleFlow.determineExistingGenerator(existingSimpleFlow); // FIXME: This is gross
      // We need to regenerate the template if certain required vars are missing from the existing template
      // But we need a much cleaner system to do it

      let regenerate = false;

      if (['pin', 'location+pin'].includes(newSimpleFlow.vars.validation)) {
        const templateVars = _.get(existingSimpleFlow, 'flow.template.vars');

        if (templateVars && (!templateVars.punchByPin || !templateVars.punchByLocationAndPin)) {
          regenerate = true;
        }
      }

      return _await(_invokeIgnored(function () {
        if (!_.isEqual(newGenerator, existingGenerator) || regenerate) {
          return _await(_this11.client.flows.details(newGenerator.template, newGenerator.input), function (newFlow) {
            SimpleFlow.setTemplate(newSimpleFlow, newFlow);
          });
        }
      }));
    });
  }

  updateSlug(updates
  /*: { offer: Offer }*/
  ) {
    const _this12 = this;

    return _call(function () {
      const {
        id: offerId,
        slug: existingSlug
      } = _this12.getInstance('offer');

      const newSlug = updates.offer.slug;

      const {
        propertyId,
        businessId
      } = _this12.context.serialize();

      return newSlug && newSlug === existingSlug ? _await() : _await(_this12.client.properties.for(propertyId).businesses.for(businessId).offers.for(offerId).updateSlug(newSlug || updates.offer.headline), function (updatedSlug) {
        // TODO: What's the best way to update an instance's fields?
        // Keep slug as a separate instance key?
        // (We can do this here because the pipeline is meant to keep an internal mutable representation of the offer)
        _this12.getInstance('offer').slug = updatedSlug;
      });
    });
  }

  planLimitPrecheck(updates
  /*: Object*/
  ) {
    const _this13 = this;

    return _call(function () {
      const existingOffer = _this13.getInstance('offer');

      if (updates.offer.enabled === false) return _await();

      const {
        propertyId,
        businessId
      } = _this13.context.serialize();

      const testableSchedules = buildSchedulesOfAllTypes(updates.schedules[0]); // Throws

      return _await(_awaitIgnored(_this13.client.properties.for(propertyId).businesses.for(businessId).checkLimits({
        offerId: existingOffer.id,
        locationIds: updates.locations,
        visibleSchedules: schedulesToPrecheckParams(testableSchedules, 'usable'),
        discoverableSchedules: schedulesToPrecheckParams(testableSchedules, 'discoverable'),
        usableSchedules: schedulesToPrecheckParams(testableSchedules, 'usable')
      })));
    });
  }

  conditionallyDisable(updates
  /*: { offer: Offer }*/
  ) {
    const existingOffer = this.getInstance('offer');
    if (!existingOffer.id) return false;
    if (updates.offer.enabled === false && existingOffer.enabled === true) return this.disable();
    return false;
  }

  conditionallyEnable(updates
  /*: { offer: Offer }*/
  ) {
    const existingOffer = this.getInstance('offer');
    if (updates.offer.enabled === true && existingOffer.enabled === false) return this.enable();
    return false;
  }

  enable()
  /*: Promise<any>*/
  {
    const {
      id: offerId
    } = this.getInstance('offer');
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    return this.client.properties.for(propertyId).businesses.for(businessId).offers.for(offerId).enable();
  }

  disable()
  /*: Promise<any>*/
  {
    const {
      id: offerId
    } = this.getInstance('offer');
    const {
      propertyId,
      businessId
    } = this.context.serialize();
    return this.client.properties.for(propertyId).businesses.for(businessId).offers.for(offerId).disable();
  }

  updatePins(updates
  /*: { offer: Offer }*/
  )
  /*: Promise<any>*/
  {
    const _this14 = this;

    return _call(function () {
      const {
        id: offerId
      } = _this14.getInstance('offer');

      const {
        propertyId,
        businessId
      } = _this14.context.serialize();

      return _await(_this14.client.access.checkPermissions({
        propertyId,
        businessId
      }, ['property.business.offer.pins.get']), function (hasPermissions) {
        if (!hasPermissions) return null;
        const newPins = updates.offer.pins; // Set newPins to empty array to clear

        return newPins ? _this14.client.properties.for(propertyId).businesses.for(businessId).offers.for(offerId).codes.setPins(newPins) : false;
      });
    });
  }

}

OfferUpdatePipeline.deprecatedValidateWithOldOfferModel = (offer
/*: Offer*/
) =>
/*: ?string*/
{
  const hasLocations = offer.locations && offer.locations.length;
  if (offer.enabled && !hasLocations) return 'Offer cannot be published without Locations';
  return null;
};

module.exports = OfferUpdatePipeline;